<template>
    <div>
        <div v-if="shouldShowErrorMessage" class="text-error-message">{{ $t('Error: Product not found. Contact konfigurator@templed.de and send this SKU') }}: {{ generatedSku }}</div>
        <button v-if="(current_step > 1 && product_configurator_id === 1) || (current_step > 2 && product_configurator_id === 3)" class="btn btn-outline-primary mt-4 mb-4" @click.prevent="goToStep(editPlanning && current_step === 3 ? (current_step - 2) : (current_step - 1))">
            {{ $t('Previous') }}
        </button>
        <button class="btn btn-primary mt-4 mb-4"
                v-if="current_step < 4"
                @click.prevent="advanceStep"
                :disabled="(this.current_step < 3 && !clickableSteps.includes(this.current_step + 1 ))
                || (this.current_step === 2 && this.planningFormSubmitting)
                || (this.current_step === 3 && this.lltFormSubmitting)
                || (this.current_step === 3 && !this.validatedSteps.includes(3))">
            <span v-if="current_step === 3">{{ product_configurator_id === 1 ? $t('Create lighting line') : $t('Create track system') }}</span>
            <span v-else>{{ $t('Continue') }}</span>
        </button>
    </div>
</template>

<script>

    export default {
        props: [
            'current_step',
            'clickableSteps',
            'validatedSteps',
            'lstForm',
            'planningFormFields',
            'luminaireLineFormFields',
            'editPlanning',
            'product_configurator_id',
            'calculatedProductPrice',
            'generatedSku',
            'allLuminaireSelectionStepsSelected'
        ],

        data() {
            return {
                planningFormSubmitting: false,
                lltFormSubmitting: false,
            }
        },

        methods: {

            advanceStep() {

                // Current step not validated
                if (!this.validatedSteps.includes(this.current_step)) {
                    return;
                }

                if (this.current_step === 1 && this.authenticated && !this.editPlanning) {
                    this.$emit('get-projects', true);
                } else if (this.current_step === 1 && this.authenticated && this.editPlanning) {
                    console.log('current step 1 & edit');
                }

                if (this.current_step === 2 && !this.planningCreated && !this.editPlanning) {
                    return this.submitPlanning();
                }

                if (this.current_step === 3) {
                    return this.updatePlanning();
                }

                if (this.current_step !== 3) {
                    this.$emit('update-current-step', this.editPlanning ? this.current_step + 2 : this.current_step + 1);
                }

            },

            goToStep(stepToGo) {
                let stepToGoToIsValidated = this.clickableSteps.includes(stepToGo);

                if ( stepToGoToIsValidated ) {
                    this.$emit('update-current-step', stepToGo);
                } else if ( stepToGo <= this.max_step ) {
                    this.$emit('update-current-step', stepToGo);
                }
            },

            submitPlanning() {
                this.planningFormSubmitting = true;
                this.$emit('update-loading', true);

                axios.post('/api/plannings', Object.assign( {}, this.planningFormFields, this.lstForm))
                    .then(response => {

                        this.planningFormSubmitting = false;
                        this.$emit('update-planning-created', true);
                        this.$emit('set-planning-id', response.data.data.id);

                        this.$emit('update-loading', false);
                        this.$emit('update-current-step', this.current_step + 1);

                    }).catch(error => {
                    if (error.response.status === 422) { // Validation Error
                        this.$emit('update-planning-form-errors', error.response.data.errors);
                    }
                    this.planningFormSubmitting = false;
                    this.$emit('update-loading', false);
                });
            },

            updatePlanning() {

                this.lltFormSubmitting = true;
                this.$emit('update-loading', true);

                let planningData = {};
                let planningId = null;
                if (this.editPlanning) {
                    planningData = this.luminaireLineFormFields;
                    // Update led module configuration for SKU generation
                    Object.keys(this.lstForm).forEach(function (key) {
                        planningData[key] = this.lstForm[key];
                    }, this);
                    planningId = this.planningFormFields.id;

                } else {
                    planningData = Object.assign( {}, this.planningFormFields, this.lstForm, this.luminaireLineFormFields);
                    planningId = this.luminaireLineFormFields.planning_id;
                }

                axios.put('/api/plannings/' + planningId, planningData)
                    .then(response => {
                        this.lltFormSubmitting = false;

                        this.$emit('update-planning-created', true);
                        this.$emit('update-current-step', this.current_step + 1);
                        this.$emit('update-loading', false);

                        this.$router.push({ name: 'plannings.arrange', params: { id: planningId } });

                    }).catch(error => {
                    if (error.response.status === 422 || error.response.status === 403) { // Validation Error
                        this.$emit('update-planning-form-errors', error.response.data.errors);
                        this.$swal.fire({
                            icon: 'error',
                            title: this.$t('There was an error'),
                            text: '(' + error.response.status + ')',
                            confirmButtonColor: '#3CA2A4'
                        });
                    }
                    this.lltFormSubmitting = false;
                    this.$emit('update-loading', false);
                });
            },



        },

        computed: {
            shouldShowErrorMessage() {
                const result = !this.calculatedProductPrice && this.allLuminaireSelectionStepsSelected;
                return result;
            }
        }
    }
</script>

<style scoped>
.text-error-message {
    color: #ff0000;
    background-color: #ffeeee;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    border: 1px solid #ff0000;
    font-weight: bold;
}
</style>
